<template>
    <div ref="qrcode"></div>
  </template>
  <script>
  import QRCode from "qrcodejs2";
  export default {
    name: "QRCode",
    props: {
      text: {
        type: String,
        required: true,
      },
      width: {
        type: Number,
        default: 172,
      },
      height: {
        type: Number,
        default: 172,
      },
    },
    mounted() {
      // this.generateQRCode();
    },
    methods: {
      generateQRCode() {
        new QRCode(this.$refs.qrcode, {
          text: this.text,
  
          width: this.width,
  
          height: this.height,
        });
      },
    },
  };
  </script>
    <style scoped>
  </style>
  